// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3VoYh","insightsList":"newBusinessInsightsMenu_insightsList__16ken","active":"newBusinessInsightsMenu_active__138sh"};